"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseKey"));

var _Base2 = _interopRequireDefault(require("./Base"));

var _config = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_config");

var AbstractRoutes = /*#__PURE__*/function (_Base) {
  (0, _inherits2["default"])(AbstractRoutes, _Base);

  var _super = (0, _createSuper2["default"])(AbstractRoutes);

  function AbstractRoutes(config) {
    var _this;

    (0, _classCallCheck2["default"])(this, AbstractRoutes);
    _this = _super.call(this);
    Object.defineProperty((0, _assertThisInitialized2["default"])(_this), _config, {
      writable: true,
      value: null
    });
    (0, _classPrivateFieldLooseBase2["default"])((0, _assertThisInitialized2["default"])(_this), _config)[_config] = config;
    return _this;
  }

  (0, _createClass2["default"])(AbstractRoutes, [{
    key: "config",
    get: function get() {
      if (!(0, _classPrivateFieldLooseBase2["default"])(this, _config)[_config]) {
        throw new Error('config не задан');
      }

      return (0, _classPrivateFieldLooseBase2["default"])(this, _config)[_config];
    }
  }, {
    key: "render",
    value: function render() {
      throw new Error('Метод "render" не переопределен');
    }
  }]);
  return AbstractRoutes;
}(_Base2["default"]);

var _default = AbstractRoutes;
exports["default"] = _default;